import { OptionTypes, } from '@polestar/component-warehouse-react/components/options-list/OptionsList';
import { isOptionSelected } from '@polestar/component-warehouse-react/components/options-list/OptionsList.helpers';
export const flattenOptions = (options, multiple) => {
    const flatOptions = [];
    options === null || options === void 0 ? void 0 : options.forEach((option) => {
        if (option.type === OptionTypes.group && option.options) {
            if (multiple) {
                flatOptions.push(option);
            }
            flatOptions.push(...option.options);
        }
        else {
            flatOptions.push(option);
        }
    });
    return flatOptions;
};
export const firstIndexByText = (value, options, whitelistedOptionLabels = ['label']) => {
    value = value.toLowerCase();
    let firstHit = null;
    options.find((item, nr) => {
        const hit = whitelistedOptionLabels.filter((key) => item[key].toLowerCase().startsWith(value));
        firstHit = hit.length > 0 ? nr : firstHit;
        return hit.length > 0;
    });
    return firstHit;
};
export const indexByValue = (options, value) => {
    return value === null
        ? -1
        : Math.max(options.findIndex((option) => option.value === value || option.label === value), options.findIndex((option) => !option.disabled), 0);
};
/**
 * Added this function because the value in the dropdown fields support number
 * A simplified `selectedOption.value || selectedOption.label` won't cut it when value = 0
 */
export const getValue = (selectedOption) => {
    if (selectedOption && selectedOption.value !== undefined) {
        return selectedOption.value;
    }
    return (selectedOption ? selectedOption.label : null) || '';
};
export const getValues = (selectedOptions) => {
    if ((selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.length) === 0) {
        // empty
        return undefined;
    }
    return selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.map((selectedOption) => {
        if (selectedOption && selectedOption.value !== undefined) {
            return selectedOption.value;
        }
        return (selectedOption ? selectedOption.label : null) || '';
    }).filter((item) => item !== '');
};
const filterSelectedOptions = (currentValues, changedValue) => {
    let removed = false;
    // check to remove from the current values
    const list = currentValues.filter((item) => {
        if ((item === null || item === void 0 ? void 0 : item.value) === (changedValue === null || changedValue === void 0 ? void 0 : changedValue.value)) {
            removed = true;
            return false;
        }
        return true;
    });
    if (!removed) {
        // not yet selected, so add it
        list.push(changedValue);
    }
    return list;
};
/**
 * Determine if a selection should be unselected
 *
 * @param current the current selection (probably an Array)
 * @param changed the changed property
 */
export const determineSelection = (current, changed) => {
    let currentValues = (Array.isArray(current) ? current : [current]) || [];
    const changedValues = (Array.isArray(changed) ? changed : [changed]) || [];
    changedValues.map((changedValue) => {
        var _a, _b;
        if ((changedValue === null || changedValue === void 0 ? void 0 : changedValue.type) === 'group') {
            const missing = [];
            const remove = [];
            // check if sub options are selected
            (_a = changedValue.options) === null || _a === void 0 ? void 0 : _a.map((option) => {
                if (!isOptionSelected(option, currentValues)) {
                    missing.push(option);
                }
                else {
                    remove.push(option);
                }
            });
            if (remove.length === ((_b = changedValue === null || changedValue === void 0 ? void 0 : changedValue.options) === null || _b === void 0 ? void 0 : _b.length)) {
                // all selected, so remove them
                currentValues = currentValues.filter((currentValue) => !remove.includes(currentValue));
            }
            else {
                // add missing items
                missing.map((item) => {
                    currentValues.push(item);
                });
            }
        }
        else {
            currentValues = filterSelectedOptions(currentValues, changedValue);
        }
    });
    return currentValues;
};
